<template>
  <div class="quote-status-detail-wrapper zhenyun-theme">
    <!-- 草稿状态 -->
    <div class="status-describe" v-if="status == 1">
      <el-link type="primary" style="color: #3062f8;cursor:text" :underline="false"
        >报价草稿</el-link
      >
      <div class="status-button-box">
        <el-button
          type="primary"
          @click="handleSubmit"
          v-if="
            [5, 13].includes(detailInfo.rfqStatus) &&
            !detailInfo.isExistRejectQuote
          "
          >立即提交</el-button
        >
        <el-button
          @click="handleGoEdit"
          v-if="
            [5, 13].includes(detailInfo.rfqStatus) &&
            !detailInfo.isExistRejectQuote
          "
          >修改报价</el-button
        >
      </div>
    </div>
    <!-- 已提交状态 -->
    <div class="status-describe" v-if="status == 2">
      <el-link type="primary" style="color: #3b9aff;cursor:text" :underline="false"
        >报价已提交，采购处理报价后公开联系方式</el-link
      >
      <div class="status-button-box">
        <el-button
          type="primary"
          @click="handleGoCreate"
          v-if="
            [5, 13].includes(detailInfo.rfqStatus) &&
            !detailInfo.isExistRejectQuote
          "
          >重新报价</el-button
        >
        <el-button
          @click="handleWithdraw"
          v-if="
            [5, 13].includes(detailInfo.rfqStatus) &&
            !detailInfo.isExistRejectQuote
          "
          >撤回报价</el-button
        >
      </div>
    </div>
    <!-- 已候选状态 -->
    <div class="status-describe" v-if="status == 7">
      <el-link type="primary" style="color: #ff7800;cursor:text" :underline="false"
        >报价已候选，请尽快与采购联系沟通报价细节</el-link
      >
      <div class="status-button-box">
        <contractPopover :contractMap="contractMap" v-model="popoverVisible">
          <el-button
            type="primary"
            slot="reference"
            style="margin-right: 12px"
            size="mini"
            @click="getContactInfo(detailInfo.rfqId)"
            :loading="loadingContactInfo"
          >
            <i class="iconfont icon-call" style="font-size: 14px"></i>
            联系采购</el-button
          >
        </contractPopover>

        <el-button
          @click="handleGoCreate"
          v-if="
            [5, 13].includes(detailInfo.rfqStatus) &&
            !detailInfo.isExistRejectQuote
          "
          >重新报价</el-button
        >
        <el-button
          @click="handleWithdraw"
          :loading="withdrawLoading"
          v-if="
            [5, 13].includes(detailInfo.rfqStatus) &&
            !detailInfo.isExistRejectQuote
          "
          >撤回报价</el-button
        >
      </div>
    </div>
    <div class="status-describe" v-if="status == 8">
      <el-link type="primary" style="color: #20b820;cursor:text" :underline="false"
        >报价已接受，请与采购联系确认合作下单</el-link
      >
      <div class="status-button-box">
        <contractPopover :contractMap="contractMap" v-model="popoverVisible">
          <el-button
            type="primary"
            slot="reference"
            style="margin-right: 12px"
            size="mini"
            @click="getContactInfo(detailInfo.rfqId)"
            :loading="loadingContactInfo"
          >
            <i class="iconfont icon-call" style="font-size: 14px"></i>
            联系采购</el-button
          >
        </contractPopover>
      </div>
    </div>
    <!-- 已撤回 -->
    <div class="status-describe" v-if="status == 4">
      <span class="chehui-text">报价已撤回</span>
      <div class="status-button-box">
        <el-button
          type="primary"
          @click="handleGoCreate"
          v-if="
            [5, 13].includes(detailInfo.rfqStatus) &&
            !detailInfo.isExistRejectQuote
          "
          >重新报价</el-button
        >
      </div>
    </div>
    <!-- 已撤销-->
    <div class="status-describe" v-if="status == 5">
      <span class="chehui-text">询盘已撤销</span>
    </div>
    <!-- 已拒绝 -->
    <div class="status-describe" v-if="status == 3">
      <span class="rejected-text">报价已拒绝</span>
      <p class="rejected-remark">
        {{ detailInfo.reason }}
      </p>
    </div>
    <div class="status-step" v-if="![1, '1', 4, '4', 5, '5'].includes(status)">
      <zhenyunStep
        :stepList="stepList"
        :currentStep="currentStep"
      ></zhenyunStep>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import zhenyunStep from './zhenyun-step.vue'
import {
  withdrawQuoteOrderApi,
  getContactInfoApi,
  getCheckQuoteApi,
} from '@/utils/api/zhenyun.js'
import contractPopover from './contract-popover.vue'
import { onlineUrl } from '@/utils/config'
export default {
  name: 'quote-status',
  props: {
    status: {
      type: Number,
    },
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    zhenyunStep,
    contractPopover,
  },
  data() {
    return {
      loadingContactInfo: false,
      popoverVisible: false,
      contractMap: {},
      stepList: [],
      currentStep: 0,
      withdrawLoading: false,
    }
  },
  methods: {
    getContactInfo(id) {
      this.loadingContactInfo = true
      getContactInfoApi({ rfqId: id })
        .then((res) => {
          const { rspResult, data } = res
          if (rspResult.bizCode == 200) {
            this.contractMap = data || {}
            this.popoverVisible = true
          }
        })
        .finally(() => {
          this.loadingContactInfo = false
        })
    },
    handleSubmit() {
      this.$emit('handleSubmit')
    },
    async handleWithdraw() {
      this.$confirm('确定要撤回报价吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.withdrawApi()
        })
        .catch(() => {})
    },
    async withdrawApi() {
      try {
        this.withdrawLoading = true
        const res = await withdrawQuoteOrderApi({
          rfqQuoteId: this.detailInfo.id,
        })
        this.withdrawLoading = false
        const { rspResult } = res
        if (rspResult.bizCode == 200) {
          this.$message.success('撤回报价成功')
          this.$emit('updateQuoteStatus')
        }
      } catch (error) {
        this.withdrawLoading = false
      }
    },
    handleGoEdit() {
      this.$router.push({
        name: 'update-quote',
        params: {
          id: this.detailInfo.rfqIdAes,
        },
        query: {
          quoteId: this.detailInfo.id,
        },
      })
    },
    async checkQuoteStatus() {
      try {
        const res = await getCheckQuoteApi()
        const { rspResult, data } = res
        return rspResult.bizCode === 200 ? data.flag : false
      } catch (error) {
        return false
      }
    },
    handleGoCreate() {
      this.checkQuoteStatus().then((res) => {
        if (res === true) {
          this.$router.push({
            name: 'created-quote',
            params: {
              id: this.detailInfo.rfqIdAes,
            },
          })
        } else {
          window.open(`${onlineUrl}/supplier-profile?u=1`)
        }
      })
    },
  },
  mounted() {},
  watch: {
    detailInfo: {
      immediate: true,
      handler(val) {
        if (!val) {
          return
        }
        this.stepList = [
          {
            label: '已报价',
            time: '',
          },
          {
            label: '报价已候选',
            time: '',
          },
          {
            label: '报价已接受',
            time: '',
          },
          {
            label: '完成',
            time: '',
          },
        ]
        let time7 = null
        let resolveTime = null
        let rejectedTime = null
        if (val.nodes) {
          time7 = val.nodes.find((k) => k.status == 7)?.createTime //候选时间
          resolveTime = val.nodes.find((k) => k.status == 8)?.createTime // 接受时间
          rejectedTime = val.nodes.find((k) => k.status == 3)?.createTime // 拒绝时间
        }
        this.stepList[0].time =
          this.detailInfo.submitTime &&
          moment(this.detailInfo.submitTime).format('YYYY-MM-DD HH:mm:ss')
        //已提交状态
        if (val.status == 2) {
          this.currentStep = 0
          return
        }
        if (val.status == 7) {
          this.currentStep = 1
          time7 &&
            (this.stepList[1].time = moment(time7).format(
              'YYYY-MM-DD HH:mm:ss'
            ))
          return
        }
        if (val.status == 8) {
          this.currentStep = 3
          time7 &&
            (this.stepList[1].time = moment(time7).format(
              'YYYY-MM-DD HH:mm:ss'
            ))
          resolveTime &&
            (this.stepList[2].time = moment(resolveTime).format(
              'YYYY-MM-DD HH:mm:ss'
            ))
          return
        }
        if (val.status == 3) {
          this.currentStep = 2
          this.stepList = [
            {
              label: '已报价',
              time:
                this.detailInfo.submitTime &&
                moment(this.detailInfo.submitTime).format(
                  'YYYY-MM-DD HH:mm:ss'
                ),
            },
            {
              label: '报价已拒绝',
              time:
                rejectedTime &&
                moment(rejectedTime).format('YYYY-MM-DD HH:mm:ss'),
            },
            {
              label: '结束',
            },
          ]
          return
        }
      },
    },
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.quote-status-detail-wrapper {
  margin: 8px 16px 0;
  border-radius: 8px;
  background: #fbfbfb;
  padding: 16px;
  display: flex;
  // align-items: center;
  .status-describe {
    flex: 1;
    .status-button-box {
      margin-top: 17px;
    }
  }
  .status-step {
    flex: 1;
    margin-left: 15px;
  }
}
.chehui-text {
  align-self: stretch;
  color: #b4bcc5;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.rejected-text {
  color: #ff081f;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  line-height: 22px;
}
.rejected-remark {
  color: #666666;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}
</style>
